const initialState = {
  salaries: [],
  salaryReport: null,
  loading: false,
  actionLoading: false,
  error: null
};

const SalaryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Salaries
    case 'FETCH_SALARIES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_SALARIES_SUCCESS':
      return {
        ...state,
        loading: false,
        salaries: action.payload,
        error: null
      };
    case 'FETCH_SALARIES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Generate Salary
    case 'GENERATE_SALARY_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GENERATE_SALARY_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        salaries: [action.payload, ...state.salaries],
        error: null
      };
    case 'GENERATE_SALARY_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Pay Salary
    case 'PAY_SALARY_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'PAY_SALARY_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        salaries: state.salaries.map((s) => (s.id === action.payload.id ? action.payload : s)),
        error: null
      };
    case 'PAY_SALARY_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Salary Report
    case 'FETCH_SALARY_REPORT_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_SALARY_REPORT_SUCCESS':
      return {
        ...state,
        loading: false,
        salaryReport: action.payload,
        error: null
      };
    case 'FETCH_SALARY_REPORT_FAILURE':
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default SalaryReducer;
